module.exports = __webpack_public_path__ + "static/media/Laugo_18.fefc440f.jpg";